module.exports = __webpack_public_path__ + "static/media/LED灯屏模块.79741472.png";